import {setSessionStorage} from '../util/Natutil'
import {Nullable} from '../../../app/TypeHelpers'
import {SessionStorageHelper} from '../../../SessionStorageHelper'
import {GuestLoginInfo} from '../../components/login/repository/NatPostGuestLogin'

export const GuestLoginInfoSessionStorageKey = {
    LOGIN_USER_ROLE_ID: 'loginUserRoleId',
    SELECTED_CONDOMINIUM_CD: 'selectedCondominiumCd',
    SELECTED_CONDOMINIUM_NAME: 'selectedCondominiumName',
    SELECTED_RIDGE_CD: 'selectedRidgeCd',
    SELECTED_RIDGE_NAME: 'selectedRidgeName',
    SELECTED_ROOM_NUMBER: 'selectedRoomNumber',
    TWO_FACTOR_AUTH_NECESSARY: 'twoFactorAuthNecessary'
} as const
type GuestLoginInfoSessionStorageKey =
    typeof GuestLoginInfoSessionStorageKey[keyof typeof GuestLoginInfoSessionStorageKey];

export class NatGuestLoginInfoSessionStorageHelper {

    static getStringItemOrNull(key: GuestLoginInfoSessionStorageKey): Nullable<string> {
        return SessionStorageHelper.getStringItemOrNull(key)
    }

    static getNumberItemOrNull(key: GuestLoginInfoSessionStorageKey): Nullable<number> {
        return SessionStorageHelper.getNumberItemOrNull(key)
    }

    static setSessionStorageByKey(key: GuestLoginInfoSessionStorageKey, value: any): void {
        setSessionStorage(key, value)
    }

    static setSessionStorageUserInfo(guestLoginUserInfo: GuestLoginInfo): void {
        setSessionStorage(GuestLoginInfoSessionStorageKey.LOGIN_USER_ROLE_ID, guestLoginUserInfo.roleId)
        setSessionStorage(GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_CD, guestLoginUserInfo.condominiumCd)
        setSessionStorage(GuestLoginInfoSessionStorageKey.SELECTED_CONDOMINIUM_NAME, guestLoginUserInfo.condominiumName)
        setSessionStorage(GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_CD, guestLoginUserInfo.ridgeCd)
        setSessionStorage(GuestLoginInfoSessionStorageKey.SELECTED_RIDGE_NAME, guestLoginUserInfo.ridgeName)
        setSessionStorage(GuestLoginInfoSessionStorageKey.SELECTED_ROOM_NUMBER, guestLoginUserInfo.roomNumber)
        setSessionStorage(
            GuestLoginInfoSessionStorageKey.TWO_FACTOR_AUTH_NECESSARY, guestLoginUserInfo.twoFactorAuthNecessary
        )
    }
}
